<template>
  <div>
    <Breadcrumbs :classes="{ confirm: true }"/>
    <div class="customer-form--warpper">
      <h3 class="text-customer mb-4 font-hiraginoSans-w6">予約者情報を入力してください</h3>
      <div class="pb-3 font-hiraginoSans-w3">
        <div class="field mt-2">
          <label class="label-control required label-form-booking-mobile">
            氏名
            <span class="label-required">必須</span>
          </label>
          <div class="d-flex">
            <input type="text" v-model="customer.last_name" placeholder="姓"
                   class="form-control input-form-customer-mobile input-flex-shrink mr-3 font-hiraginoSans-w6"/>
            <input type="text" v-model="customer.first_name" placeholder="名"
                   class="form-control input-form-customer-mobile input-flex-shrink font-hiraginoSans-w6"/>
          </div>
          <div class="d-flex">
            <div class="w-50 field-errors-message last_name mr-3"></div>
            <div class="w-50 field-errors-message first_name"></div>
          </div>
        </div>

        <div class="field mt-2">
          <label class="label-control required label-form-booking-mobile">
            ふりがな
            <span class="label-required">必須</span>
          </label>
          <div class="d-flex">
            <input type="text" v-model="customer.last_name_kana" placeholder="せい"
                   class="form-control input-form-customer-mobile input-flex-shrink mr-3 font-hiraginoSans-w6"/>
            <input type="text" v-model="customer.first_name_kana" placeholder="めい"
                   class="form-control input-form-customer-mobile input-flex-shrink font-hiraginoSans-w6"/>
          </div>
          <div class="d-flex">
            <div class="w-50 field-errors-message last_name_kana mr-3"></div>
            <div class="w-50 field-errors-message first_name_kana"></div>
          </div>
        </div>

        <div class="field">
          <label class="pt-3 label-control required label-form-booking-mobile">
            メールアドレス
            <span class="label-required">必須</span>
          </label>
          <div class="email-input">
            <input type="email" v-model="customer.email" placeholder="example@example.com"
                   class="form-control input-form-customer-mobile"/>
          </div>
          <div class="mb-2 field-errors-message email"></div>
          <div class="text-note">
            <p class="text-note-bellow-email privacy font-hiraginoSans-w6">
              ※予約完了のメールをお送りします。携帯電話のメール設定でドメイン指定受信等を設定されている場合は予約完了メールが届くように【@carecle.com】のドメイン受信設定をお願い致します。
            </p>
          </div>
        </div>

        <div class="field mb-3">
          <label class="pt-3 label-control required label-form-booking-mobile">
            生年月日
            <span class="label-required">必須</span>
          </label>
          <div class="d-flex">
            <input type="text" v-model="customer.birth_date"
                   class="form-control birthdate_selector input-form-customer-mobile input-flex-shrink" v-combodate
                   @change="updateBirthDate($event)"/>
          </div>
          <div class="mb-2 field-errors-message birth_date"></div>
        </div>

        <div class="field">
          <label class="label-control label-form-booking-mobile">性別</label>
          <div class="d-flex text-gender">
            <p class="mr-5">
              <input type="radio" id="customer_gender_male" v-model="customer.gender" value="male"
                     class="magic-radio input-flex-shrink"/>
              <label for="customer_gender_male">男性</label>
            </p>
            <p class="mr-5">
              <input type="radio" id="customer_gender_female" v-model="customer.gender" value="female"
                     class="magic-radio input-flex-shrink"/>
              <label for="customer_gender_female">女性</label>
            </p>
            <p class="mr-5">
              <input type="radio" id="customer_gender_no_anwser" v-model="customer.gender" value="no_answer"
                     class="magic-radio input-flex-shrink"/>
              <label for="customer_gender_no_anwser">回答しない</label>
            </p>
            <p class="mr-5">
              <input type="radio" id="customer_gender_other" v-model="customer.gender" value="other"
                     class="magic-radio input-flex-shrink"/>
              <label for="customer_gender_other">その他</label>
            </p>
          </div>
          <div class="field gender-detail-input" v-show="customer.gender === 'other'">
           <p>
             <input type="text" v-model="customer.gender_detail"
                   class="form-control input-form-customer-mobile input-flex-shrink mr-3 font-hiraginoSans-w6 detail-gender" maxlength="30"/>
            </p>
          </div>
          <div class="col-sm-2"></div>
          <div class="col-md-10 field-errors-message gender"></div>
        </div>

        <div class="field mb-3">
          <label class="pt-2 label-control required label-form-booking-mobile">
            携帯電話番号
            <span class="label-required">必須</span>
          </label>
          <div class="tel-input">
            <input type="tel" v-model="customer.tel" placeholder="012-3456-7890"
                   class="form-control input-form-customer-mobile" id="tel"/>
          </div>
          <div class="field-errors-message tel"></div>
        </div>

        <div class="field mb-3">
          <label class="pt-3 label-control required label-form-booking-mobile">
            パスワード
            <span class="label-required">必須</span>
          </label>
          <input type="password" v-model="customer.password" autocomplete="off" placeholder="******"
                 class="form-control input-form-customer-mobile" id="customer_password"/>
          <div class="field-errors-message password"></div>
        </div>

        <div class="field">
          <label class="pt-2 label-control required label-form-booking-mobile">
            パスワード（確認)
            <span class="label-required">必須</span>
          </label>
          <input type="password" v-model="customer.password_confirmation" autocomplete="off" placeholder="******"
                 class="form-control input-form-customer-mobile" id="customer_password_confirmation"/>
          <div class="field-errors-message password_confirmation"></div>
        </div>

        <div class="mt-5 text-note">
          <p class="text-note-bellow-email text-muted privacy font-hiraginoSans-w6">
            ※上記フォームに記入し予約完了した際に、個人情報を含む情報を利用事業者及びWEB予約機能を提供する株式会社ケアクルが取得することに同意したものとみなされます。
            <br/>
            ケアクルにおける個人情報の取り扱いについては、
            <a href="https://corp.carecle.com/privacy/" target="_blank" class="text-primary">プライバシーポリシー</a>
            をご確認ください。
          </p>
        </div>
      </div>
    </div>
    <div class="footer-wrapper py-5">
      <div class="container">
        <div class="footer-buttons d-flex">
          <span id="backStepChooseTimeprice" class="back-step mr-2" @click="goBack">&lt; 戻る</span>
          <div class="btn-choose-timeprice-option next-step text-center scroll-top" @click="checkCustomer">
            次へ
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from './Breadcrumbs.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'FormCustomer',
  components: {
    Breadcrumbs
  },
  props: {
    currentCustomer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      customer: { ...this.currentCustomer }
    };
  },
  computed: {
    ...mapGetters('permalink', ['selectedEvent', 'selectedTimeprice', 'selectedTherapist', 'selectedTimepriceOptions', 'customerData']),
    room_booking() {
      return {
        time_start: this.selectedEvent?.startStr,
        time_end: this.selectedEvent?.endStr,
        timeprice_id: this.selectedTimeprice?.id,
        therapist_id: this.selectedTherapist?.id,
        timeprice_option_ids: this.selectedTimepriceOptions.map(option => option.id),
      }
    }
  },
  directives: {
    combodate: {
      inserted(el, binding, vnode) {
        $(el).combodate({
          format: 'YYYY-MM-DD',
          template: 'YYYY MM DD',
          minYear: 1900,
          maxYear: new Date().getFullYear()
        }).on('change', function() {
          vnode.context.customer.birth_date = el.value;
        });

        setTimeout(() => {
          const yearSelect = el.nextElementSibling.querySelector('select:nth-of-type(1)');
          const monthSelect = el.nextElementSibling.querySelector('select:nth-of-type(2)');
          const daySelect = el.nextElementSibling.querySelector('select:nth-of-type(3)');

          if (yearSelect) $(yearSelect).after('<span class="text-birthdate">年</span>');
          if (monthSelect) $(monthSelect).after('<span class="text-birthdate">月</span>');
          if (daySelect) $(daySelect).after('<span class="text-birthdate">日</span>');
        }, 100);
      },
      update(el, binding, vnode) {
        $(el).combodate('setValue', vnode.context.customer.birth_date);
      }
    }
  },
  mounted() {
    this.handlePhoneNumber();
    if (this.customerData && Object.keys(this.customerData).length > 0) {
      this.customer = this.customerData;
    }
  },
  methods: {
    ...mapActions('permalink', ['setCustomerData']),
    updateBirthDate(event) {
      this.customer.birth_date = event.target.value;
    },
    goBack() {
      this.$emit('goBack');
    },

    handlePhoneNumber() {
      this.reformat("#tel", "format_split_3-4-4");

      document.querySelector("#tel").addEventListener("input", (event) => {
        this.reformat("#tel", "format_split_3-4-4");
      });

      document.querySelector("#tel").addEventListener("keydown", (event) => {
        if (event.key === "Backspace") {
          let phone = event.target.value;
          let cursorPosition = event.target.selectionStart;

          if (phone[cursorPosition - 1] === "-") {
            let newNumber = phone.slice(0, cursorPosition - 1);
            this.customer.tel = newNumber;
            event.target.selectionStart = cursorPosition - 1;
            event.target.selectionEnd = cursorPosition - 1;
          }
        }
      });
    },

    reformat(id, type) {
      let phone = document.querySelector(id).value || "";

      let replaceValue = this.replaceNotNumber(phone);

      if (type === "format_split_3-4-4") {
        document.querySelector(id).value = this.refreshPhone(replaceValue);
      } else if (type === "format_full_9_to_12") {
        document.querySelector(id).value = replaceValue.slice(0, 12);
      }
    },

    replaceNotNumber(string) {
      let cleanedString = string.replace(/[^\d]/g, "");
      return cleanedString;
    },

    refreshPhone(phone) {
      let phoneLength = phone.length;

      if (phoneLength > 11) {
        phone = phone.slice(0, 11);
      }

      if (phoneLength > 7) {
        phone = phone.slice(0, 7) + "-" + phone.slice(7);
      }

      if (phoneLength > 3) {
        phone = phone.slice(0, 3) + "-" + phone.slice(3);
      }

      return phone;
    },

    checkCustomer() {
      const self = this;
      const formData = $.param({
        customer: self.customer,
        room_booking: self.room_booking
      });
      $.ajax({
        url: '/room_bookings/check_valid_customer',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        type: 'post',
        data: formData,
        success: function(res) {
          if (res.status === 'fail') {
            self.updateErrorMessages(res.message);
          } else {
            $('#customerInfoBookingMobile').html(res);
            const email = $('input#customer_email').val();
            $('#customerEmail').html(email);
            self.clearErrorMessages();
            self.setCustomerData(self.customer);
            self.$emit('goNext');
          }
        }
      });
    },
    updateErrorMessages(messages) {
      this.clearErrorMessages();
      if (messages.email) $('.email').html(messages.email);
      if (messages.password) $('.password').html(messages.password);
      if (messages.last_name) $('.last_name').html(messages.last_name);
      if (messages.first_name) $('.first_name').html(messages.first_name);
      if (messages.last_name_kana) $('.last_name_kana').html(messages.last_name_kana);
      if (messages.first_name_kana) $('.first_name_kana').html(messages.first_name_kana);
      if (messages.tel) $('.tel').html(messages.tel);
      if (messages.birth_date) $('.birth_date').html(messages.birth_date);
      if (messages.password_confirmation) $('.password_confirmation').html(messages.password_confirmation);
    },
    clearErrorMessages() {
      $('.email').html('');
      $('.password').html('');
      $('.last_name').html('');
      $('.first_name').html('');
      $('.last_name_kana').html('');
      $('.first_name_kana').html('');
      $('.tel').html('');
      $('.birth_date').html('');
      $('.password_confirmation').html('');
    }
  },
  watch: {
    'customer.gender'(newVal) {
      if (newVal !== 'other') {
        this.customer.gender_detail = '';
      }
    }
  }
};
</script>

<style scoped>
.text-customer {
  font-size: 20px;
  font-weight: 700;
  color: #333;
}
.label-form-booking-mobile {
  font-family: "HiraginoSans-W6", serif;
}
.customer-form--warpper {
  padding-left: 15px;
  padding-right: 15px;
}
.text-gender {
  font-size: 16px;
  color: #00122E;
  font-family: "HiraginoSans-W6", serif;
  font-weight: 700;
}
.birthdate_selector select {
  font-weight: normal;
}
input.detail-gender {
  margin-top: -10px;
}
</style>
